import {ActivatedRoute} from '@angular/router';

declare var google: any
import { Message } from 'src/app/core/class/message';
import {Component, NgZone, OnInit, ViewChild} from '@angular/core';
import { CommonService } from 'src/app/core/services/common.service';
import { LinkAccountService } from 'src/app/core/services/link-account.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { finalize } from 'rxjs/operators';
import {DatePipe} from '@angular/common';
import {LINK_TYPE} from './utilities/link-type.enum';

@Component({
  selector: 'app-link-account',
  templateUrl: './link-account.component.html',
  styleUrls: ['./link-account.component.scss']
})
export class LinkAccountComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  account: any = ''
  accountZalo: any = {}
  accountGoogle: any = {}
  accountApple: any = {}
  accountFacebook: any = {}
  hasZaloLink: boolean = false;
  hasGoogleLink: boolean = false;
  hasAppleLink: boolean = false;
  hasFacebookLink: boolean = false;
  client_id: string = ''
  currentPassword: string = ''
  GOOGLE_AUTH_URL: string = ''
  ZALO_AUTH_URL: string = ''
  redirect_uri : string = ''
  showPassword: boolean = false
  linkMode: 'GOOGLE' | 'ZALO' | 'APPLE' | 'FACEBOOK' = 'GOOGLE';
  queryParams: any = {};
  redirectType: string = '';
  LINK_TYPE = LINK_TYPE;

  constructor(
    private message: Message,
    private commonSrv: CommonService,
    private ggAccountSrv: LinkAccountService,
    private dialog: MatDialog,
    private toastSrv: ToastrService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private ngZone: NgZone,
  ){
    const fragment = window.location.hash.substring(1);
    const params = new URLSearchParams(fragment);

    const idToken = params.get('id_token');

    if (idToken) {
      this.getInfoAccount(idToken)
    } else {
    this.getInfoAccount("")
    }
  }

  ngOnInit(): void {
    this.checkCallback();
    this.getInfoLink();
  }

  ngAfterViewInit(){

  }

  checkCallback() {
    this.route.queryParamMap.subscribe(params => {
      const code = params.get('code');
      const state = params.get('state');
      this.redirectType = params.get('type');

      if (code && state) {
        this.queryParams = {
          code,
          state,
        };
        const body = {
          zaloRequest: this.queryParams,
          type: this.redirectType.toUpperCase()
        }
        this.ggAccountSrv.linkAccountZalo(body)
          .subscribe((res: any) => {
            if(res && res.success) {
              this.toastSrv.success(this.message.getMessage('linked_account.linked_zalo.link_success'));
              this.getInfoLink();
            }
            else {
                this.toastSrv.error(res.message);
            }
          })
      }
    })
  }


  getInfoLink(){
    this.ggAccountSrv.getAllLink().subscribe(res =>{
      console.log(res);
      if(res.success && res.data && res.data.length > 0){
        const data: any[] = JSON.parse(res.data);
        const zaloAccount = data.find((e: any) => e.type === LINK_TYPE.ZALO);
        const googleAccount = data.find((e: any) => e.type === LINK_TYPE.GOOGLE);
        const appleAccount = data.find((e: any) => e.type === LINK_TYPE.APPLE);
        const facebookAccount = data.find((e: any) => e.type === LINK_TYPE.FACEBOOK);
        this.accountZalo = zaloAccount ? zaloAccount : {};
        this.accountGoogle = googleAccount ? googleAccount : {};
        this.accountApple = appleAccount ? appleAccount : {};
        this.accountFacebook = facebookAccount ? facebookAccount : {};

        if(Object.keys(this.accountZalo).length > 0) {
          this.hasZaloLink = true;
        }
        else {
          this.hasZaloLink = false;
        }
        if(Object.keys(this.accountGoogle).length > 0) {
          this.hasGoogleLink = true;
        }
        else {
          this.hasGoogleLink = false;
        }
        if(Object.keys(this.accountApple).length > 0) {
          this.hasAppleLink = true;
        }
        else {
          this.hasAppleLink = false;
        }
        if(Object.keys(this.accountFacebook).length > 0) {
          this.hasFacebookLink = true;
        }
        else {
          this.hasFacebookLink = false;
        }
      } else {
        this.toastSrv.error(res.message);
      }
    })
  }

  getLoginUrl(){
    if(this.client_id && this.redirect_uri){
      const params: any = new URLSearchParams({
        client_id: this.client_id,
        redirect_uri: this.redirect_uri+'/home-enterprise/connect-account',
        response_type: 'id_token',
        scope: 'openid email profile',
        nonce: this.generateRandomString(32),
        state: this.generateRandomString(16),
        prompt: 'select_account'
      });

      this.GOOGLE_AUTH_URL = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`
    }
  }

  deleteLink(mode: 'GOOGLE' | 'ZALO' | 'APPLE' | 'FACEBOOK'){
    this.linkMode = mode;
    if(this.linkMode === LINK_TYPE.GOOGLE) {
      this.confirmDialogRef = this.dialog.open(this.confirmDelete, {
        width: '365px',
        disableClose: true
      })
    } else if(this.linkMode === LINK_TYPE.ZALO) {
      this.confirmDialogRef = this.dialog.open(this.confirmDelete, {
        width: '365px',
        disableClose: true
      })
    }
  }

  getInfoAccount(idToken: any){
    this.blockUI.start()
    this.ggAccountSrv.checkLinkedAccount().pipe(finalize(()=> this.blockUI.stop())).subscribe(res => {
      if (res.success){
        if (res.data) {
          this.account = res.data
          this.blockUI.stop()
        } else {
          this.account = ''
        }

        if (idToken) {
          this.ggAccountSrv.linkAccoutGoogle({tokenGoogle: idToken}).pipe(finalize(()=> this.blockUI.stop())).subscribe(res => {
            window.history.replaceState({}, document.title, window.location.pathname)
            if (res.success){
              this.getInfoAccount("")
              this.toastSrv.success(this.message.getMessage('link_google_acount.google_account_linked'))

            } else {
              this.toastSrv.error(res.message)
            }
          })
        } else {
          this.blockUI.stop()
        }
      } else {
        this.toastSrv.error(res.message)
      }

    })
  }

  confirmDialogRef: MatDialogRef<any> | null;
  @ViewChild('confirmDelete', { static: false }) confirmDelete: any;

  closeConfirmDialog(data: any){
    if (data){
      this.blockUI.start()
      if(this.linkMode === LINK_TYPE.GOOGLE || this.linkMode === LINK_TYPE.APPLE || this.linkMode === LINK_TYPE.FACEBOOK) {
        this.deletingConnect(this.linkMode);
      }
      else if(this.linkMode === LINK_TYPE.ZALO) {
        this.confirmDialogRef.close('close')
        const param = {
          type: LINK_TYPE.ZALO
        }
        this.ggAccountSrv.unlinkAccountZalo(param).subscribe((res: any) => {
          console.log(res)
          if(res && res.success) {
            this.getInfoLink();
            this.toastSrv.success(this.message.getMessage('linked_account.linked_zalo.unlink_success'));
          }
          else {
            this.toastSrv.error(res.message)
          }
        })
      }
    } else {
      this.confirmDialogRef.close()
    }

    this.confirmDialogRef.afterClosed().subscribe(res => {
      if(res){
        this.getInfoAccount("")
        this.getInfoLink()
      }
    })
  }

  // Start login with firebase method
  connectWidthFirebase(method: LINK_TYPE){
    this.linkMode = method
    this.linkDialogRef = this.dialog.open(this.confirmLink, {
      width: '400px',
      disableClose: true
    })
  }

  deleteConnectFirebase(method: LINK_TYPE){
    this.linkMode = method;
    this.confirmDialogRef = this.dialog.open(this.confirmDelete, {
      width: '365px',
      disableClose: true
    })
  }

  deletingConnect(type: string){
    const param = {
      type: type
    }
    this.ggAccountSrv.unlinkAccountZalo(param).subscribe((res: any) => {
      console.log(res)
      if(res && res.success) {
        this.confirmDialogRef.close()
        this.blockUI.stop()
        let message: string = '';
        switch(this.linkMode) {
          case LINK_TYPE.APPLE: {
            message = this.message.getMessage('linked_account.linked_apple.unlink_success');
            break;
          }
          case LINK_TYPE.FACEBOOK: {
            message = this.message.getMessage('linked_account.linked_facebook.unlink_success');
            break;
          }
          case LINK_TYPE.GOOGLE: {
            message = this.message.getMessage('linked_account.linked_google.unlink_success');
            break;
          }
        }
        this.toastSrv.success(message);
        this.getInfoLink();
      }
      else {
        this.toastSrv.error(res.message)
      }
    })
  }

  closeDeleteFirebase(res: any){
    if(res){
      this.blockUI.start()
      switch(this.linkMode){
        case LINK_TYPE.GOOGLE:
          this.deletingConnect(LINK_TYPE.GOOGLE)
          break;
        case LINK_TYPE.FACEBOOK:
          this.deletingConnect(LINK_TYPE.FACEBOOK)
          break;
        case LINK_TYPE.APPLE:
          this.deletingConnect(LINK_TYPE.APPLE)
          break;
        default:
          break;
      }
    }
    this.confirmDialogRef.close()
  }

  connect(token: any){
    this.blockUI.start()
    this.ggAccountSrv.linkAccountZalo({idToken: token}).pipe(finalize(()=>{this.blockUI.stop();this.logoutFirebase()}))
    .subscribe((rs: any) => {
      this.ngZone.run(() => {
        if(rs && rs.success) {
          let message: string = '';
          switch(this.linkMode) {
            case LINK_TYPE.APPLE: {
              message = this.message.getMessage('linked_account.linked_apple.link_success');
              break;
            }
            case LINK_TYPE.FACEBOOK: {
              message = this.message.getMessage('linked_account.linked_facebook.link_success');
              break;
            }
            case LINK_TYPE.GOOGLE: {
              message = this.message.getMessage('linked_account.linked_google.link_success');
              break;
            }
          }
          this.toastSrv.success(message);
          this.getInfoLink();
        }
        else {
          this.toastSrv.error(rs.message);
          this.getInfoLink();
        }
      })
    },
    (error: any) => {
      this.getInfoLink();
    }
    )
  }

  async connectWithGoogle() {
    try {
      if(this.isSafari()){
        this.closeSafariDialog();
      }
      const res = await this.ggAccountSrv.loginWithGoogle();
      if (!res.user) {
        console.error(this.message.getMessage('linked_account.linked_google.cannot_get_id_token'))
        return;
      }
      const idToken = await res.user.getIdToken();
      this.connect(idToken);
      // this.logoutFirebase();
    } catch (err) {
      console.error(this.message.getMessage('linked_account.linked_google.cannot_get_id_token'))
    }
  }

  async connectWithFacebook() {
    try {
      if(this.isSafari()){
        this.closeSafariDialog();
      }
      const res = await this.ggAccountSrv.loginWithFacebook();
      if (!res.user) {
        console.error(this.message.getMessage('linked_account.linked_facebook.cannot_get_id_token'))
        return;
      }
      const idToken = await res.user.getIdToken();
      this.connect(idToken);
      // this.logoutFirebase();
    } catch (err) {
      console.error(this.message.getMessage('linked_account.linked_facebook.cannot_get_id_token'))
    }
  }

  async connectWithApple() {
    try {
      if(this.isSafari()){
        this.closeSafariDialog();
      }
      const res = await this.ggAccountSrv.loginWithApple();
      if (!res.user) {
        console.error(this.message.getMessage('linked_account.linked_apple.cannot_get_id_token'))
        return;
      }
      const idToken = await res.user.getIdToken();
      this.connect(idToken);
      // this.logoutFirebase();
    } catch (err) {
      console.error(this.message.getMessage('linked_account.linked_apple.cannot_get_id_token'))
    }
  }

  logoutFirebase(){
    this.ggAccountSrv.logoutFirebase();
  }

  getNameMethod(name: string){
    return name.charAt(0).toLocaleUpperCase()+name.slice(1).toLocaleLowerCase()
  }

  getRemoveMessage(){
    return this.message.getMessage('linked_account.linked_google.confirm_delete_link').replace('{0}', this.getNameMethod(this.linkMode))
  }
  // End login with firebase method

  generateRandomString(length: number){
    const array = new Uint8Array(length);
    crypto.getRandomValues(array);
    return btoa(String.fromCharCode(...array))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
  };

  onLink(mode: 'GOOGLE' | 'ZALO' | 'APPLE' | 'FACEBOOK'){
    this.linkMode = mode;
    this.linkDialogRef = this.dialog.open(this.confirmLink, {
      width: '400px',
      disableClose: true
    })
  }

  linkDialogRef: MatDialogRef<any> | null;
  @ViewChild('confirmLink', { static: false }) confirmLink: any;

  linkConfirmDialog(data: any){
    if (data){
      this.blockUI.start()
      this.ggAccountSrv.validatePassword({currentPassword: this.currentPassword}).pipe(finalize(()=> this.blockUI.stop())).subscribe(res =>{
        if (res.success) {
          this.linkDialogRef.close(res)
          this.showPassword = false;
          this.currentPassword = ''
          if(this.isSafari() && this.linkMode != LINK_TYPE.ZALO){
            setTimeout(()=> {
              this.confirmSafariDialogRef = this.dialog.open(this.confirmConnectInSafari, {
                width: '365px',
                disableClose: true
              })
            },100)
            return;
          }
          switch (this.linkMode) {
            case LINK_TYPE.ZALO: {
              this.commonSrv.generateChallengeCodeAndState()
                .subscribe((res: any) => {
                    console.log(res)
                    if(res && res.success && res.data) {
                      const data = res.data;
                      const callbackUrl = `${data.callBackUrl}/home-enterprise/connect-account?type=ZALO`
                      const zaloUrl = 'https://oauth.zaloapp.com/v4/permission?';
                      this.ZALO_AUTH_URL = `${zaloUrl}redirect_uri=${callbackUrl}&app_id=${data.zaloAppId}&code_challenge=${data.codeChallenge}&state=${data.state}&code=${data.codeChallenge}`
                      console.log(this.ZALO_AUTH_URL)
                      window.location.href = this.ZALO_AUTH_URL
                    }
                    else {
                      this.toastSrv.error(res.message)
                    }
                  },
                  error => {
                    this.toastSrv.error(this.message.getMessage('messages.update_certificate_renew_server_error'))
                  })
              break;
            }
            case LINK_TYPE.GOOGLE: {
              this.connectWithGoogle();
              break;
            }
            case LINK_TYPE.APPLE: {
              this.connectWithApple();
              break;
            }
            case LINK_TYPE.FACEBOOK: {
              this.connectWithFacebook();
              break;
            }
          }
        } else {
          this.toastSrv.error(res.message)
        }
      })
    } else {
      this.linkDialogRef.close()
      this.showPassword = false;
      this.currentPassword = ''
    }
  }




  confirmSafariDialogRef: MatDialogRef<any> | null;
  @ViewChild('confirmConnectInSafari', { static: false }) confirmConnectInSafari: any;
  private isSafari(): boolean{
    const ua = navigator.userAgent.toLocaleLowerCase()
    return ua.includes('safari') && !ua.includes('chrome') && !ua.includes('android')
  }
  closeSafariDialog(){
    this.confirmSafariDialogRef.close();
  }

  featureInDevelopment(){
    this.toastSrv.error(this.message.getMessage('link_google_acount.feature_in_development'))
  }
}
